import { useCallback } from "react"
import { download, generateCsv, mkConfig } from "export-to-csv"
import { DateTime } from "luxon"
import { InternalUsersResponse } from "../gdprApi"
import { useDateTime } from "../../../../localization/useDateTime"

export function useExportContactList() {
    const dateTimeFactory = useDateTime()

    const handleExport = useCallback(
        (data: InternalUsersResponse) => {
            if (!data.users || data.users.length === 0) {
                return
            }

            // Convert to CSV
            const csvOptions = mkConfig({
                fieldSeparator: ",",
                quoteStrings: true,
                decimalSeparator: ".",
                useBom: true,
                useKeysAsHeaders: true,
                filename: `GDPR-contact-list-${dateTimeFactory.formatDate(DateTime.now())}`,
            })

            const exportRows = data.users.map((user) => ({
                Email: user.email || "",
                Name: "", // Currently we hide the name when exporting contact list
                Roles: user.roles?.join(",") || "",
            }))

            const csv = generateCsv(csvOptions)(exportRows)
            download(csvOptions)(csv)
        },
        [dateTimeFactory],
    )

    return { handleExport }
}

